import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { CreateStepCircle } from './CreateStepCircle';
import { CreateStepArgs } from './types';

type CreateStepProps<T> = CreateStepArgs<T> & {
  index: number;
  isSelected: boolean;
  classNames?: {
    wrapper?: string;
  };
};

export const CreateStep = <T,>({ title, isSelected, isCompleted, classNames, index }: CreateStepProps<T>) => {
  const { t } = useTranslation();

  return (
    <li
      data-selected={isSelected}
      className={twMerge(
        'group/step flex flex-1 text-secondary-700 font-semibold opacity-50',
        'data-[selected=true]:opacity-100',
        '[&:has(~li[data-selected=true])]:text-tertiary-700 [&:has(~li[data-selected=true])]:opacity-100',
        'motion-safe:*:transition-colors motion-safe:duration-500 motion-reduce:*:transition-none',
        classNames?.wrapper
      )}
    >
      <div className='flex max-w-[70%] items-start gap-3'>
        <CreateStepCircle index={index} isCompleted={isCompleted} />
        <p className='break-all pt-0.5 text-sm first-letter:capitalize'>{t(title as any)}</p>
      </div>
      <hr className='mx-1 mt-2.5 grow border-t-4 border-dotted border-primary-border group-last-of-type/step:hidden' aria-hidden={true} />
    </li>
  );
};
